// Generated by scripts/generate-us-port-codes.mjs from CBP/Census Schedule D — do not edit by hand.
import type { UsPort } from './port-types';

// One lazy chunk per customs district, so a page only downloads its own district.
export const PORT_DATA: Record<string, () => Promise<UsPort[]>> = {
  '01': () => import('./data/d01').then(m => m.PORTS),
  '02': () => import('./data/d02').then(m => m.PORTS),
  '04': () => import('./data/d04').then(m => m.PORTS),
  '05': () => import('./data/d05').then(m => m.PORTS),
  '07': () => import('./data/d07').then(m => m.PORTS),
  '09': () => import('./data/d09').then(m => m.PORTS),
  '10': () => import('./data/d10').then(m => m.PORTS),
  '11': () => import('./data/d11').then(m => m.PORTS),
  '13': () => import('./data/d13').then(m => m.PORTS),
  '14': () => import('./data/d14').then(m => m.PORTS),
  '15': () => import('./data/d15').then(m => m.PORTS),
  '16': () => import('./data/d16').then(m => m.PORTS),
  '17': () => import('./data/d17').then(m => m.PORTS),
  '18': () => import('./data/d18').then(m => m.PORTS),
  '19': () => import('./data/d19').then(m => m.PORTS),
  '20': () => import('./data/d20').then(m => m.PORTS),
  '21': () => import('./data/d21').then(m => m.PORTS),
  '23': () => import('./data/d23').then(m => m.PORTS),
  '24': () => import('./data/d24').then(m => m.PORTS),
  '25': () => import('./data/d25').then(m => m.PORTS),
  '26': () => import('./data/d26').then(m => m.PORTS),
  '27': () => import('./data/d27').then(m => m.PORTS),
  '28': () => import('./data/d28').then(m => m.PORTS),
  '29': () => import('./data/d29').then(m => m.PORTS),
  '30': () => import('./data/d30').then(m => m.PORTS),
  '31': () => import('./data/d31').then(m => m.PORTS),
  '32': () => import('./data/d32').then(m => m.PORTS),
  '33': () => import('./data/d33').then(m => m.PORTS),
  '34': () => import('./data/d34').then(m => m.PORTS),
  '35': () => import('./data/d35').then(m => m.PORTS),
  '36': () => import('./data/d36').then(m => m.PORTS),
  '37': () => import('./data/d37').then(m => m.PORTS),
  '38': () => import('./data/d38').then(m => m.PORTS),
  '39': () => import('./data/d39').then(m => m.PORTS),
  '41': () => import('./data/d41').then(m => m.PORTS),
  '45': () => import('./data/d45').then(m => m.PORTS),
  '46': () => import('./data/d46').then(m => m.PORTS),
  '47': () => import('./data/d47').then(m => m.PORTS),
  '49': () => import('./data/d49').then(m => m.PORTS),
  '51': () => import('./data/d51').then(m => m.PORTS),
  '52': () => import('./data/d52').then(m => m.PORTS),
  '53': () => import('./data/d53').then(m => m.PORTS),
  '54': () => import('./data/d54').then(m => m.PORTS),
  '55': () => import('./data/d55').then(m => m.PORTS),
};
